module.exports = __webpack_public_path__ + "img/element-icons-120-x-76-ic-rank-10@3x.83398a7f.png";